import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Footer } from 'site-modules/shared/components/footer/footer';
import { FloodlightAd } from 'site-modules/shared/components/floodlight/floodlight-ad';
import { SEOHead } from 'site-modules/shared/pages/seo';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { SpaLinks } from 'site-modules/shared/components/spa-links/spa-links';
import { ProfileContextAsync } from 'site-modules/shared/components/profile/profile-context-async';
import { ExperimentsPanel } from 'site-modules/shared/components/experiment/panel/experiments-panel';
import { AdsContextSwitch } from 'site-modules/shared/components/ads-context/ads-context-switch';
import { ClientSideRender } from 'site-modules/shared/components/client-side-render/client-side-render';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';
import { ErrorPageMessage } from 'site-modules/shared/components/error-page-message/error-page-message';
import { PubpixelAd } from 'site-modules/shared/components/pubpixel/pubpixel-ad';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { VisitorModel } from 'client/data/models/visitor';
import { PressHeader } from 'site-modules/editorial/components/press/press-header/press-header';
import { SkipToMainContent } from 'site-modules/shared/components/skip-to-main-content/skip-to-main-content';

export class PressDecorator extends Component {
  static preload(store) {
    const preloader = new ModelPreloader(store);
    preloader.resolve('rttSegment', VisitorModel);
    return preloader.load();
  }

  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <div className="edm-page">
        <ErrorBoundary>
          <SkipToMainContent />
          <SEOHead {...this.props} />
        </ErrorBoundary>
        <ErrorBoundary>
          <FeatureFlag name="testSpa">
            <SpaLinks />
          </FeatureFlag>
        </ErrorBoundary>
        <ErrorBoundary>
          <PressHeader />
        </ErrorBoundary>
        <ErrorBoundary message={ErrorPageMessage}>{this.props.children}</ErrorBoundary>
        <ErrorBoundary>
          <Footer />
        </ErrorBoundary>
        <ErrorBoundary>
          <FeatureFlag name="ads">
            <ErrorBoundary>
              <PubpixelAd />
            </ErrorBoundary>
            <ErrorBoundary>
              <FloodlightAd />
            </ErrorBoundary>
            <ErrorBoundary>
              <AdsContextSwitch />
            </ErrorBoundary>
          </FeatureFlag>
        </ErrorBoundary>
        <ErrorBoundary>
          <ClientSideRender>
            <ProfileContextAsync />
          </ClientSideRender>
        </ErrorBoundary>
        <ErrorBoundary>
          <ClientSideRender>
            <ExperimentsPanel />
          </ClientSideRender>
        </ErrorBoundary>
      </div>
    );
  }
}
